import moment from "moment-timezone";
import he from "he";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import Localize from "../../locale/Localize";
import { DEVICE_ORIENTATION_TYPES, DEVICE_TYPES } from "../../constants/Constants";
import { empty } from "../../shared/utility";
import reduxStore from "../../configureEnvStore";
import { isLocalUserStreaming } from "../../components/Twilio/Room/roomFunction";
import { LogFirebase } from "../firestore";

const commaSpace = ", ";
let fontSize = "18px;";
export default class GetImageWatermarkService {
    WatermarkDiv(FSize, bookmarkHtml, locationHtml, datetext, time, width, height) {
        const watermarkDiv =
            `<div xmlns="http://www.w3.org/1999/xhtml">
                        <div style="width: 100%;">
                            <div id="watermarkdiv" style="font-family: Tahoma; font-size: ` +
            FSize +
            `; background: #fff; color: #000; opacity: 1; ">
                                <div style="padding: 12px 3px 0px 5px; margin: 0 0.025em 0.025em 0;">` +
            bookmarkHtml +
            locationHtml +
            " " +
            "<b>" +
            datetext +
            "</b>" +
            time.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
            `</div>
                            </div>
                        </div>
                    </div>`;
        const tempDiv = document.createElement("div");
        tempDiv.id = "watermarkAttachDiv";
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.style.left = "-1000px";
        tempDiv.style.top = "-1000px";
        document.body.appendChild(tempDiv);

        const newNode = document.getElementById("watermarkAttachDiv");
        newNode.innerHTML = watermarkDiv;
        const divHeight = document.getElementById("watermarkdiv").clientHeight;
        let waterMarkDivHeight;
        if (width < 200 && height < 200) {
            // for the low resolution video set watermark div height smaller
            waterMarkDivHeight = divHeight - 15;
        } else {
            waterMarkDivHeight = divHeight;
        }
        document.body.removeChild(tempDiv);
        return waterMarkDivHeight;
    }

    getWaterMarkSVG(args) {
        const { from, FSize, bookmarkHtml, locationHtml, datetext, time, width, canvasHeight } = args;
        let svgString = "";
        if (from === "camera") {
            svgString =
                '<svg xmlns="http://www.w3.org/2000/svg" height="' +
                canvasHeight +
                '" width="' +
                width +
                '">' +
                '<foreignObject width="100%" height="100%">' +
                `<div xmlns="http://www.w3.org/1999/xhtml">
                            <div style="position: absolute; width: 100%; left: 0; bottom: 0px;">
                                <div id="watermarkdiv"
                                    style="font-family: Tahoma; font-size: ` +
                FSize +
                `; background: #fff; color: #000; opacity: 1; ">
                                    <div style="padding: 8px 3px 12px 5px; margin: 0 0.025em 0.025em 0;">` +
                "<b>" +
                datetext +
                " " +
                "</b>" +
                time.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
                `</div>
                                </div>
                            </div>
                        </div>
                </foreignObject>
            </svg>`;
        } else {
            svgString =
                '<svg xmlns="http://www.w3.org/2000/svg" height="' +
                canvasHeight +
                '" width="' +
                width +
                '">' +
                '<foreignObject width="100%" height="100%">' +
                `<div xmlns="http://www.w3.org/1999/xhtml">
                            <div style="position: absolute; width: 100%; left: 0; bottom: 0px;">
                                <div id="watermarkdiv"
                                    style="font-family: Tahoma; font-size: ` +
                FSize +
                `; background: #fff; color: #000; opacity: 1; ">
                                    <div style="padding: 8px 3px 12px 5px; margin: 0 0.025em 0.025em 0;">` +
                bookmarkHtml +
                locationHtml +
                "<b>" +
                datetext +
                "</b>" +
                time.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
                `</div>
                                </div>
                            </div>
                        </div>
                </foreignObject>
            </svg>`;
        }
        const encoder = new TextEncoder();
        const svgBytes = encoder.encode(svgString);
        const base64Svg = btoa(String.fromCharCode.apply(null, svgBytes));

        return "data:image/svg+xml;base64," + base64Svg;
    }

    getLocationVal(latitude, longitude) {
        let locationVal = Localize[PublicVariables.currentLanguageObj.languageCode]["not_shared"];
        if (latitude && longitude) {
            locationVal = parseFloat(parseFloat(latitude)).toFixed(4) + ", " + parseFloat(parseFloat(longitude)).toFixed(4);
        }
        return locationVal;
    }

    getTimeZone() {
        let Zonename = moment.tz.guess();
        let timezonetime = new Date();
        let timeZoneOffset = timezonetime.getTimezoneOffset();
        return moment.tz.zone(Zonename).abbr(timeZoneOffset);
    }

    setInitialValues = (paramObj) => {
        const { screenType, localOrientation, liveLat, liveLong, localSS, localVideo, fromLiveLocation } = paramObj;
        let latVal = 0;
        let longVal = 0;
        let orientation = 0;
        let device_type = 0;
        const { lat, long, oppOrientation, deviceType } = reduxStore.getState().commonReducer.OppoDetails;

        if (screenType === "location" || isLocalUserStreaming() || localSS || localVideo) {
            // For location map or local participant
            latVal = CALL_DATA.Latitude;
            longVal = CALL_DATA.Longitude;
            orientation = localOrientation;
            device_type = GLOBAL_MEETING_DATA.device_type;
        } else if (screenType === "upload-File") {
            // For uploaded file
            latVal = liveLat;
            longVal = liveLong;
        } else if (screenType === "markup" || screenType === "ocr") {
            // For remote participant from markup or OCR
            latVal = CALL_DATA.Latitude;
            longVal = CALL_DATA.Longitude;
            orientation = oppOrientation;
            device_type = deviceType;
        } else {
            // For other remote participants
            latVal = lat;
            longVal = long;
            orientation = oppOrientation;
            device_type = deviceType;
        }
        if (fromLiveLocation === "livemap") {
            // Override with live location if applicable
            latVal = liveLat;
            longVal = liveLong;
        }
        return { latVal, longVal, orientation, device_type };
    };

    handleBookmarkSetup = (bookmark, device_type, orientation) => {
        let bookmarkHtml = "";
        let bookmarkHeight = 0;
        if (!empty(bookmark)) {
            let bktext = bookmark.bookmarkName;
            const patt = new RegExp(/\s/g);
            const hasSpace = patt.test(bktext);
            //no space and length large
            if (
                hasSpace === false &&
                bktext.length > 40 &&
                device_type != DEVICE_TYPES.DESKTOP &&
                (orientation === DEVICE_ORIENTATION_TYPES.ONE_PORTRAIT || orientation === DEVICE_ORIENTATION_TYPES.TWO_UPSIDE_DOWN)
            ) {
                bktext = bktext.substring(0, 40) + " " + bktext.substring(40, 50);
            }
            let bname = he.encode(bktext, { encodeEverything: true });
            if (!empty(bname)) {
                bookmarkHtml = bname + "<br/>";
                bookmarkHeight = 20;
                LogFirebase("Bookmarks", "add_watermark", bookmark.bookmarkName);
            }
        }
        return { bookmarkHtml, bookmarkHeight };
    };

    handleLocationHTML = (screenType, width, height, device_type, orientation, text) => {
        let locationHtml = "";
        let waterMarkCondition =
            device_type != DEVICE_TYPES.DESKTOP &&
            (orientation === DEVICE_ORIENTATION_TYPES.ONE_PORTRAIT || orientation === DEVICE_ORIENTATION_TYPES.TWO_UPSIDE_DOWN);
        if (screenType === "upload-File") {
            if (width >= height) {
                // file is in landscape
                waterMarkCondition = false;
            } else {
                fontSize = Math.min(25, Math.floor(20 / ((width / height) * 1.5))) + "px;";
                waterMarkCondition = true;
            }
        }
        if (width < 200 && height < 200) {
            // for the low resolution video set watermark fontsize smaller
            fontSize = "10px;";
        }
        if (PublicVariables.featureFlag && PublicVariables.featureFlag.WATERMARKONPHOTOS === "1") {
            if (waterMarkCondition) {
                // mobile
                locationHtml =
                    '<span style=" margin-right: 10px;">' +
                    "<b>" +
                    Localize[PublicVariables.currentLanguageObj.languageCode]["location_colon"] +
                    " " +
                    "</b>" +
                    text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
                    "</span>";
            } else {
                // desktop
                locationHtml =
                    "<b>" +
                    Localize[PublicVariables.currentLanguageObj.languageCode]["location_colon"] +
                    " " +
                    "</b>" +
                    text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
                    commaSpace;
            }
        }

        return { locationHtml, fontSize };
    };

    fetchImageWaterMark(obj) {
        const { screenType, width, height, localOrientation, bookmark, liveLat, liveLong, localSS, localVideo, fromLiveLocation } = obj;

        const { latVal, longVal, orientation, device_type } = this.setInitialValues({
            screenType,
            localOrientation,
            liveLat,
            liveLong,
            localSS,
            localVideo,
            fromLiveLocation,
        });

        const text = this.getLocationVal(latVal, longVal, orientation);

        const time = moment().local().format("MMM DD, YYYY") + " " + moment().local().format("hh:mm:ss A") + " " + this.getTimeZone();

        const { bookmarkHtml, bookmarkHeight } = this.handleBookmarkSetup(bookmark, device_type);

        const { locationHtml, fontSize } = this.handleLocationHTML(screenType, width, height, device_type, orientation, text);

        const watermarkHeight = this.WatermarkDiv(
            fontSize,
            bookmarkHtml,
            locationHtml,
            Localize[PublicVariables.currentLanguageObj.languageCode]["date_colon"] + " ",
            time,
            width,
            height
        );
        const canvasHeight = height + watermarkHeight + bookmarkHeight;
        const reqParams = {
            from: screenType,
            FSize: fontSize,
            bookmarkHtml: bookmarkHtml,
            locationHtml: locationHtml,
            datetext: Localize[PublicVariables.currentLanguageObj.languageCode]["date_colon"] + " ",
            time: time,
            width: width,
            canvasHeight: canvasHeight,
        };
        const src = this.getWaterMarkSVG(reqParams);
        return {
            canvasHeight: canvasHeight,
            imageSrc: src,
        };
    }
}
